///<reference path="../../../../../typings/index.d.ts"/>
///<reference path="../short-cuts.interfaces.ts"/>
///<reference path="../../baseClasses/dataMaintenance.interface.ts"/>


module Meevo.Components.ShortCuts {
    import IShortCutGroup = Meevo.Components.ShortCuts.IShortCutGroup;

    export abstract class ShortCutsStateManagerController {
        protected abstract shortCutGroup: IShortCutGroup | { [key: number]: IShortCutGroup };

        private _noun: Meevo.Model.NounEnum;
        protected get noun(): Meevo.Model.NounEnum {
            return this._noun;
        }
        protected set noun(value: Meevo.Model.NounEnum) {
            this._noun = value;
        }

        get mode(): Meevo.Model.MaintenanceFormState {
            return Meevo.Model.MaintenanceFormState.Readonly;
        }

        protected get currentModeGroup(): IShortCutGroup {
            if (this.shortCutGroup instanceof ShortCutGroup) {
                return this.shortCutGroup;
            }

            if (typeof this.mode === 'number') {
                return this.shortCutGroup[this.mode];
            }

            return new ShortCutGroup([]);
        }

        constructor(protected $scope: ng.IScope,
                    protected $state: ng.ui.IStateService,
                    protected shortCutsService: IShortCutsService) {
            const stateName: string = $state.current.name;

            $scope.$on('$stateChangeSuccess',
                (event, toState, toParams, fromState) => {
                    if (fromState.name === stateName) {
                        this.unbindHotkeys();
                    } else if (toState.name === stateName) {
                        this.bindHotkeys();
                    }
                });

            $scope.$watch(() => this.mode, () => {
                this.bindHotkeys();
            });

            this.bindHotkeys = _.debounce(this.bindHotkeys, 300);
        }

        protected bindHotkeys() {
            this.shortCutsService.activateGroup(this.currentModeGroup, this.noun);
        }

        protected unbindHotkeys() {
            this.shortCutsService.deactivateGroup(this.currentModeGroup);
        }
    }
}
